import { AnyAction } from "redux";

import * as types from "./types";

import { initialState } from "./index";


export default function processEngineeringReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case types.OPEN_PROCESS_ENGINEERING_MODAL:
      return {
        ...state,
        isProcessEngineeringModalOpen:
          action.payload.isProcessEngineeringModalOpen,
      };
    case types.CLOSE_PROCESS_ENGINEERING_MODAL:
      return {
        ...state,
        isProcessEngineeringModalOpen:
          action.payload.isProcessEngineeringModalOpen,
        hasSubmissionError: action.payload.hasSubmissionError,
      };
    case types.OPEN_PROCESS_ENGINEERING_TABLE_MODAL: {
      return {
        ...state,
        isProcessEngineeringTableModalOpen:
          action.payload.isProcessEngineeringTableModalOpen,
      };
    }
    case types.CLOSE_PROCESS_ENGINEERING_TABLE_MODAL: {
      return {
        ...state,
        isProcessEngineeringTableModalOpen:
          action.payload.isProcessEngineeringTableModalOpen,
        isEvaluationDetailsShown: action.payload.isEvaluationDetailsShown,
      };
    }
    case types.SET_PROCESS_ENGINEERING_DATA:
      return {
        ...state,
        processEvaluationData: {
          ...state.processEvaluationData,
          [action.payload.field]: action.payload.value,
        },
      };
    case types.SUBMIT_PROCESS_ENGINEERING: {
      return {
        ...state,
        isSubmitting: true,
        hasSubmissionError: false,
        processEvaluationData: {
          ...action.payload.processEvaluationData,
        },
      };
    }
    case types.SUBMIT_PROCESS_ENGINEERING_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        hasSubmissionError: false,
        submissionProcessEvaluationSuccess:
          action.payload.submissionProcessEvaluationSuccess,
        processEvaluationData: {
          ...action.payload.processEvaluationData,
        },
      };
    }
    case types.SUBMIT_PROCESS_ENGINEERING_ERROR: {
      return {
        ...state,
        isSubmitting: false,
        hasSubmissionError: true,
        submissionProcessEvaluationSuccess:
          action.payload.submissionProcessEvaluationSuccess,
      };
    }
    case types.FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES: {
      return {
        ...state,
        isFetchingStatuses: action.payload.isFetchingStatuses,
      };
    }
    case types.FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES_SUCCESS: {
      return {
        ...state,
        isFetchingStatuses: action.payload.isFetchingStatuses,
        processEngineeringStatuses: [
          ...action.payload.processEngineeringStatuses,
        ] as never[],
      };
    }
    case types.FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES_ERROR: {
      return {
        ...state,
        isFetchingStatuses: action.payload.isFetchingStatuses,
        hasFetchingStatusesError: action.payload.hasFetchingStatusesError,
      };
    }
    case types.RESET_PROCESS_ENGINEERING_EVALUATION_SUBMISISON: {
      return {
        ...state,
        submissionProcessEvaluationSuccess:
          action.payload.submissionProcessEvaluationSuccess,
      };
    }
    case types.SHOW_PROCESS_ENGINEERING_EVALUATION_DETAILS: {
      return {
        ...state,
        isEvaluationDetailsShown: action.payload.isEvaluationDetailsShown,
        selectedEvaluation: action.payload.selectedEvaluation,
      };
    }
    case types.HIDE_PROCESS_ENGINEERING_EVALUATION_DETAILS: {
      return {
        ...state,
        isEvaluationDetailsShown: action.payload.isEvaluationDetailsShown,
        selectedEvaluation: null,
      };
    }
    default:
      return state;
  }
}
